import { useAction } from "@/hooks/shared";
import { listAdminBenchmarksHandler } from "@/services";

export const useListAdminBenchmarks = () => useAction(listAdminBenchmarksHandler);
